<template>
  <b-modal v-model="showDetailModel" ok-only :title="$t('znsContent')">
    <div class="row">
      <div class="col-12">
        <p>
          <span>{{$t('sentFromOA')}}: </span>
          <b>{{oaName ? oaName : $t('undefined')}}</b>
        </p>
        <p>
          <span>{{$t('template')}}: </span>
          <b>{{templateName ? templateName : $t('undefined')}}</b>
        </p>
        <p>
          <span>{{$t('content')}}: </span>
        </p>
        <div class="alert alert-info" v-html="this.detail"></div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ZNSContent",
  data() {
    return {
      showDetailModel: false,
      detail: null,
      oaName: null,
      templateName: null
    }
  },
  methods: {
    show(template, params, oaName) {
      this.oaName = oaName;
      this.templateName = template.name;
      this.detail = template && template.desc ? template.desc : this.$t('undefined');
      if (params) {
        for (let param in params) {
          let key = `{${param}}`;
          this.detail = this.detail.replaceAll(key, `<b>${params[param]}</b>`)
        }
        this.detail = this.detail.replace(/\n/g, '<br/>')
      }
      this.showDetailModel = true;
    }
  },
  i18n: {
    messages: {
      en: {
        znsContent: 'Message Content',
        sentFromOA: 'From OA',
        content: 'Content',
      },
      vi: {
        znsContent: 'Nội dung tin nhắn',
        sentFromOA: 'Gửi từ OA',
        content: 'Nội dung',
      }
    }
  }
}
</script>